import { IoBriefcaseOutline, IoRibbonOutline, IoSchoolOutline } from "react-icons/io5";
import { Card, CardBody, CardHeader, CardTitle } from "reactstrap";

function ResumeTab({ employeeData }) {
  return (
    <div style={{ maxWidth: 760 }}>
      <Card className="mb-3">
        <CardHeader>
          <CardTitle><IoBriefcaseOutline size={18} /> Work experience</CardTitle>
        </CardHeader>
        <CardBody style={{ paddingTop: 4, paddingBottom: 4 }}>
          {employeeData?.work_experiences?.length === 0 ?
            <div className="emp-exp">
              <div>
                <div className="emp-exp-role">No work experience records found.</div>
              </div>
            </div>
          :
            employeeData?.work_experiences?.map((e, i) => (
              <div className="emp-exp" key={i}>
                <div className="emp-exp-logo"><IoBriefcaseOutline /></div>
                <div>
                  <div className="emp-exp-role">{e.job_title}</div>
                  <div className="emp-exp-org">{e.company_name}</div>
                  <div className="emp-exp-dates">{e.start_date} – {e.end_date ?? 'Present'}</div>
                  <p className="emp-exp-desc">{e.description}</p>
                </div>
              </div>
          ))}
        </CardBody>
      </Card>

      <Card className="mb-3">
        <CardHeader>
          <CardTitle><IoSchoolOutline size={18} /> Education</CardTitle>
        </CardHeader>
        <CardBody style={{ paddingTop: 4, paddingBottom: 4 }}>
          {employeeData?.educations?.length === 0 ?
            <div className="emp-exp">
              <div>
                <div className="emp-exp-role">No education records found.</div>
              </div>
            </div>
          :
            employeeData?.educations?.map((e, i) => (
              <div className="emp-exp" key={i}>
                <div className="emp-exp-logo"><IoSchoolOutline /></div>
                <div>
                  <div className="emp-exp-role">{e.field_of_study}</div>
                  <div className="emp-exp-org">{e.school_name}</div>
                  <div className="emp-exp-dates">{e.start_date} – {e.end_date ?? 'Present'}</div>
                </div>
              </div>
          ))}
        </CardBody>
      </Card>
    </div>
  );
}

export default ResumeTab;